<script>
import Item from '@/components/Product/Item'
import { products } from '@/store/product'

export default {
  components: {
    Item,
  },
  props: {
    locked: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      products,
    }
  },
}
</script>

<template>
  <div
    class="
      divide-y-2px divide-white divide-opacity-20
      border-t-2px border-b-2px border-white border-opacity-20
    "
  >
    <Item
      v-for="product in products"
      :key="product.id"
      :id="product.id"
      :name="product.name"
      :description="product.description"
      :shortDescription="product.short_description"
      :price="product.price"
      :discountPrice="product.discount_price"
      :clientPrice="product.client_price"
      :vat="product.vat"
      :minAmount="product.min_amount"
      :maxAmount="product.max_amount"
      :amountStep="product.amount_step"
      :totalInventory="product.total_inventory"
      :locked="locked"
    />
  </div>
</template>
